import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthContext.jsx";
import "../admin.css";

function ProtectedRoute({ children }) {
  const { loading, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="admin-state-screen">
        <div className="admin-state-card">
          <p className="admin-state-card__eyebrow">Checking Access</p>
          <h1>Loading admin session</h1>
          <p>Please wait while we verify your Firebase login.</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate replace state={{ from: location }} to="/login" />;
  }

  return children;
}

export default ProtectedRoute;
